import { FetchArgs, createApi } from '@reduxjs/toolkit/query/react'
import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { ChiefComplaintCategory } from '../model/ChiefComplaintCategory'
import { FilterParams, unversionedApiUrl } from './common'

const TAG = 'chief-complaint-categories'
const TAG_FAV = 'chief-complaint-categories-fav'

const getChiefComplaintCategoryByCodeQuery = (code: string): FetchArgs => ({
	url: `/system/v2/chiefcomplaintcategory/find/code/${encodeURIComponent(
		code,
	)}`,
})

export const chiefComplaintCategoryApi = createApi({
	reducerPath: 'chiefComplaintCategoryApi',
	tagTypes: [TAG, TAG_FAV],
	baseQuery: staggeredBaseQueryWithBailOut(unversionedApiUrl),
	endpoints: builder => ({
		getChiefComplaintCategoryByCode: builder.query<
			ChiefComplaintCategory,
			string
		>({
			query: getChiefComplaintCategoryByCodeQuery,
			providesTags: [TAG],
		}),

		getChiefComplaintCategories: builder.query<
			ChiefComplaintCategory[],
			FilterParams
		>({
			query: ({
				filter,
				propNames = ['code', 'description'],
				favourites,
			}: FilterParams) => ({
				url: !favourites
					? `/system/v2/chiefcomplaintcategory/paginated?q=${encodeURIComponent(
							filter,
					  )}&propNames=${propNames.join(',')}`
					: '/system/v2/chiefcomplaintcategory/favourites',
			}),
			providesTags: (result, error, query) => [
				query.favourites ? TAG_FAV : TAG,
			],
		}),
		setChiefComplaintCategorieFavourite: builder.mutation<
			ChiefComplaintCategory,
			{ code: string; favourite: boolean }
		>({
			query: ({ code, favourite }) => ({
				url: `/v1/users/chiefcomplaintcategory/${encodeURIComponent(
					code,
				)}/favourite`,
				method: 'PUT',
				body: {
					favourite,
				},
			}),
			invalidatesTags: [TAG, TAG_FAV],
		}),
	}),
})

export const {
	useGetChiefComplaintCategoriesQuery,
	useGetChiefComplaintCategoryByCodeQuery,
	useSetChiefComplaintCategorieFavouriteMutation,
} = chiefComplaintCategoryApi
